import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import BookIcon from '@material-ui/icons/BookOutlined';
import SendIcon from '@material-ui/icons/SendOutlined';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SpeakerNotes from '@material-ui/icons/SpeakerNotes';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { Checkbox } from '@material-ui/core';

function PatientsList(props) {
  const {
    history,
    onSendConsultNote,
    onBookAppointment,
    onTrackPatient,
    patients,
    classes: {
      root,
      marginLeftAuto,
      marginLeftTen,
      patientInfo,
      patientTitle,
      patientSubTitle,
      checkbox,
      drawerIcon
    },
    patientsForMerge,
    setPatientsForMerge,
    mergeMode,
  } = props;

  const onMergeCheckBox = patient => {
    const temp = patientsForMerge.map(v => v);
    if (!patientsForMerge.includes(patient)) {
      temp.push(patient);
    } else {
      temp.splice(patientsForMerge.indexOf(patient), 1);
    }
    setPatientsForMerge(temp);
  };

  const navigateToPatientPage = patient => () => {
    history.push(`/admin/patients/${patient.id}`);
  };

  return (
    <>
      {patients.map(patient => (
        <Paper key={patient.id} className={root}>
          <span
            className={patientInfo}
            onClick={navigateToPatientPage(patient)}
          >
            <span className={patientTitle}>
              {patient.lastName}, {patient.firstName}
            </span>
            <span className={patientSubTitle}>
              ({patient.gender}, {patient.birthdate})
            </span>
          </span>
          <IconButton
            className={marginLeftAuto}
            size="small"
            aria-label="Patient info"
            title="Patient info"
            color="primary"
            variant="filled"
            onClick={navigateToPatientPage(patient)}
          >
            <AccountBoxIcon  className={drawerIcon}   />
          </IconButton>
          <IconButton
            className={marginLeftTen}
            size="small"
            aria-label="book/request appointment"
            title="book/request appointment"
            color="primary"
        
            onClick={() => onBookAppointment(patient)}
          >  
            <PostAddIcon color="primary" />
          </IconButton>
          <IconButton
  
            className={marginLeftTen}
            size="small"
            aria-label="Message a Doc"
            title="Message a Doc"
            color="primary"
            onClick={() => onSendConsultNote(patient)}
          >
            <SpeakerNotes   className={drawerIcon} />
            {/* <SendIcon color="primary" /> */}
          </IconButton>
          <IconButton
            className={marginLeftTen}
            size="small"
            aria-label="track patient"
            title="track patient"
            color="primary"
            onClick={() => onTrackPatient(patient)}
          >  
            <TrackChangesIcon color="primary" />
          </IconButton>
          {mergeMode && (
            <Checkbox
              className={`${marginLeftTen} ${checkbox}`}
              checked={patientsForMerge.includes(patient)}
              onChange={() => onMergeCheckBox(patient)}
            />
          )}
        </Paper>
      ))}
    </>
  );
}

const styles = () => ({
  root: {
    padding: '11px 30px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  marginLeftTen: {
    marginLeft: 6,
  },
  patientInfo: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  patientTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'normal',
    paddingRight: '5px',
  },
  patientSubTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'normal',
    color: '#494949',
    textTransform: 'capitalize',
  },
  checkbox: {
    backgroundColor: '#FFF6BF',
    '&:hover': {
      backgroundColor: '#cdc48d',
    },
  },
});

export default withStyles(styles)(PatientsList);
